export default "__VITE_ASSET__ca697dbe__"